var React = require('react');

function SpinnericonInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#269C74"},[React.createElement("path",{"d":"M20.012 4C28.826 4.01 36 11.183 36 19.998c0 8.825-7.178 16.004-16 16.004-8.824 0-16-7.179-16.002-16L0 20c-.001 11.03 8.973 20 19.998 20 11.031 0 20-8.973 20.002-20C39.999 8.979 31.035.008 20.011.002L20.012 4z","opacity":".25","key":0}),React.createElement("path",{"d":"M.001 20l3.998.002.002-.004c-.002-8.821 7.177-15.996 16-15.996.004-.002.007-.001.012-.002L20.012.002c-.005 0-.007 0-.011-.002C8.97.001-.003 8.973.001 20z","key":1})]));
}

SpinnericonInline.defaultProps = {"width":"40","height":"40"};

module.exports = SpinnericonInline;

SpinnericonInline.default = SpinnericonInline;
